//
// Load Post By Category using Ajax
//
import { initLazyload } from "./lazyload";
import { initBlogSliders } from "./blog-sliders";

let categoryDropdownAbort = null;
let blogClickHandlerRegistered = false;

const getPostListContainer = () => document.querySelector(".postlist");

const getCategoryId = (link) => {
  if (link.dataset.cat) {
    return link.dataset.cat;
  }

  const categoryItem = link.closest("[data-blog-category]");
  return categoryItem?.dataset.blogCategory ?? "";
};

const isFilterBlogLink = (link) => link.classList.contains("filterBlogs");

const isPaginationLink = (link) => link.classList.contains("blogpagination__link");

const handleFilterClick = (link) => {
  const producers = getPostListContainer();
  if (!producers) {
    return;
  }

  const categoryTitle = document.querySelector(".blogarchiveheader--categories");
  const getPagination = link
    .closest(".bloglist--categories")
    ?.querySelectorAll(".filterBlogs");

  if (getPagination?.length) {
    getPagination.forEach((j) => {
      j.closest(".bloglist__item--category")?.classList.remove("active");
      j.classList.remove("pe-none");
    });
    link.closest(".bloglist__item--category")?.classList.add("active");
    link.classList.add("pe-none");
  }

  link.closest(".bloglist--categories")?.classList.remove("d-block");
  categoryTitle?.classList.remove("blogarchiveheader--open");

  const blogLoader = document.querySelector(".blog-post-loader");
  const btnBlogLoader1 = document.querySelector(".blogpagination__link");
  blogLoader?.classList.remove("d-none");
  if (btnBlogLoader1) {
    btnBlogLoader1.classList.add("d-none");
  }

  const url = link.href;
  const catUid = getCategoryId(link);
  const formData = new FormData();
  formData.append("id", catUid);

  producers.innerHTML = "";
  document.querySelector(".col-lg-9")?.scrollIntoView();

  fetch(url, {
    method: "POST",
    body: new URLSearchParams(formData),
  })
    .then((resp) => resp.text())
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, "text/html");
      const filterProducers = doc.querySelector(".postlist")?.innerHTML;

      blogLoader?.classList.add("d-none");
      if (btnBlogLoader1) {
        btnBlogLoader1.classList.remove("d-none");
      }

      if (filterProducers) {
        producers.innerHTML = filterProducers;
      }

      syncLoadMoreButtons();
      initLazyload();
      initBlogSliders();
    })
    .catch(() => {
      blogLoader?.classList.add("d-none");
      if (btnBlogLoader1) {
        btnBlogLoader1.classList.remove("d-none");
      }
    });
};

// All posts are already rendered on the page; items past the first
// batch carry .blog-item--hidden. Load More only reveals the next
// batch in place — no fetch and no /page/N URL is ever created.
const getLoadMoreScope = (button) => button.closest(".postlist") ?? document;

const getHiddenBlogItems = (scope) => [
  ...scope.querySelectorAll(".blog-item--hidden"),
];

const syncLoadMoreButton = (button) => {
  const pagination = button.closest(".blog-pagination");
  if (!pagination) {
    return;
  }

  pagination.style.display =
    getHiddenBlogItems(getLoadMoreScope(button)).length > 0 ? "" : "none";
};

const syncLoadMoreButtons = () => {
  document.querySelectorAll(".blogpagination__link").forEach((button) => {
    syncLoadMoreButton(button);
  });
};

const handleLoadMoreClick = (button) => {
  const scope = getLoadMoreScope(button);
  const hiddenItems = getHiddenBlogItems(scope);

  if (hiddenItems.length === 0) {
    syncLoadMoreButton(button);
    return;
  }

  const perPage = parseInt(scope.querySelector("#perPage")?.value, 10);
  const batchSize = perPage > 0 ? perPage : hiddenItems.length;

  hiddenItems.slice(0, batchSize).forEach((item) => {
    item.classList.remove("d-none", "blog-item--hidden");
  });

  syncLoadMoreButton(button);
  initLazyload();
  initBlogSliders();
};

const registerBlogClickHandler = () => {
  if (blogClickHandlerRegistered) {
    return;
  }
  blogClickHandlerRegistered = true;

  // Capture phase: preventDefault before Barba / browser navigation
  document.addEventListener(
    "click",
    (event) => {
      if (!getPostListContainer()) {
        return;
      }

      // Load More is a <button> (no href / no /page/N URL); legacy
      // markup may still render it as an <a>, so match the class first.
      const loadMoreButton = event.target.closest?.(".blogpagination__link");
      if (loadMoreButton) {
        event.preventDefault();
        event.stopPropagation();
        handleLoadMoreClick(loadMoreButton);
        return;
      }

      const link = event.target.closest?.("a");
      if (!link) {
        return;
      }

      // Category plugin nav links opt out via data-category-navigate (full page URL).
      if (isFilterBlogLink(link) && !link.hasAttribute("data-category-navigate")) {
        event.preventDefault();
        event.stopPropagation();
        handleFilterClick(link);
        return;
      }

      if (isPaginationLink(link)) {
        event.preventDefault();
        event.stopPropagation();
        handleLoadMoreClick(link);
      }
    },
    true
  );
};

export const initCategoryLoadPost = () => {
  registerBlogClickHandler();
  syncLoadMoreButtons();

  if (categoryDropdownAbort) {
    categoryDropdownAbort.abort();
  }

  categoryDropdownAbort = new AbortController();
  const { signal } = categoryDropdownAbort;

  const categoryHeader = document.querySelector(".blogarchiveheader--categories");
  const categoryList = document.querySelector(".bloglist--categories");

  if (!categoryHeader || !categoryList) {
    return;
  }

  categoryHeader.addEventListener(
    "click",
    () => {
      categoryHeader.classList.toggle("blogarchiveheader--open");
      categoryList.classList.toggle("d-block");
    },
    { signal }
  );
};

initCategoryLoadPost();
